import { SHELL } from '@workflow/ui'

export const OPS_PAGE_MEASURE = 832

// The resident sidebar needs room beside the page's normal content width.
// Below that, use the overlay drawer so opening it never squeezes the page.
export const OPS_COMPACT_BREAKPOINT = Math.max(
  SHELL.compactBreakpoint,
  SHELL.sidebarWidth + OPS_PAGE_MEASURE,
)
